/**
 * NKBA API
 * The RESTful backend behind the NKBA application
 *
 * OpenAPI spec version: V1.0.0
 * Contact: cloud@nkba.org
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Transaction {
    /**
     * globally unique id
     */
    id?: string;

    /**
     * method of purchase
     */
    type?: Transaction.Type;

    /**
     * description of transaction
     */
    description?: string;

    /**
     * created by user id
     */
    createId?: string;

    /**
     * created timestamp
     */
    createAt?: string;

    /**
     * account id of transaction
     */
    accountId?: string;

    /**
     * order id, if this transaction was part of an order
     */
    orderId?: string;

    /**
     * amount of transaction (positive value if payment, negative value if receivable)
     */
    amount?: number;

    /**
     * check or wire number
     */
    checkNumber?: string;

    /**
     * processing fee, if there is a fee
     */
    fee?: number;

    /**
     * date/time of the payout, if the transaction has been disbursed from stripe
     */
    stripePayoutAt?: number;

    /**
     * human-readable auto-incrementing transaction number
     */
    number?: number;

    /**
     * id of the product
     */
    productId?: string;

    /**
     * charge id on stripe, if the transaction was a charge or refund charge
     */
    stripeChargeId?: string;

    /**
     * payout id on stripe, if the transaction has been disbursed from stripe
     */
    stripePayoutId?: string;

    /**
     * order number, if this transaction was part of an order
     */
    orderNumber?: number;

    /**
     * timestamp of transaction
     */
    at?: string;

    /**
     * date of transaction
     */
    date?: string;

}

export namespace Transaction {

    export enum Type {
            CHARGE = <any> 'CHARGE',
            CHECK = <any> 'CHECK',
            WIRE = <any> 'WIRE',
            RECEIVABLE = <any> 'RECEIVABLE',
            REFUND_CHARGE = <any> 'REFUND_CHARGE',
            REFUND_CHECK = <any> 'REFUND_CHECK',
            CANCEL = <any> 'CANCEL',
            ADJUSTMENT = <any> 'ADJUSTMENT'
    }
}



// WEBPACK FOOTER //
// ./src/common/api/models/Transaction.ts